import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Button,
    Divider
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import AddressForm from './AddressForm';

const AddressesSection = () => {
    const { control } = useFormContext();

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'addresses'
    });

    const addAddress = () => {
        append({
            address: '',
            relevance: 'marital_residence',
            label: '',
            effective_start: '',
            effective_end: ''
        });
    };

    return (
        <Paper elevation={1} sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="h6">
                    Addresses ({fields.length})
                </Typography>
                <Button
                    type="button"
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={addAddress}
                >
                    Add Address
                </Button>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Record the marital residence and any other case-relevant addresses
                (post-separation home, prior residence, vacation property). The
                marital residence reduces analysis noise — a party's own home area
                is not treated as a trip.
            </Typography>

            {fields.length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                    No addresses added yet. Click "Add Address" to get started.
                </Typography>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {fields.map((field, index) => (
                        <Box key={field.id}>
                            <AddressForm
                                index={index}
                                onRemove={() => remove(index)}
                            />
                            {index < fields.length - 1 && <Divider sx={{ mt: 2 }} />}
                        </Box>
                    ))}
                </Box>
            )}
        </Paper>
    );
};

export default AddressesSection;
